import { useContext, useEffect, useState } from "react";

import { SearchAncillaryAssetsRequest } from "../../../../common/api/master-api/assets/search/ancillary-requests-responses/SearchAncillaryAssetsRequest";
import { SearchAncillaryAssetsResponse } from "../../../../common/api/master-api/assets/search/ancillary-requests-responses/SearchAncillaryAssetsResponse";
import { useAssetsApi } from "../../../../common/api/master-api/assets/useAssetsApi";
import { AssetItem, mapToAssetsListItem } from "../../common/AssetItem";
import { SingleAncillaryContext } from "../context/SingleAncillaryContext";
import { AncillaryAssetsListUrlFilters } from "./useAncillaryAssetsListUrlFilters";

interface UseAncillaryAssetsProps {
    filters: AncillaryAssetsListUrlFilters;
}

export const useAncillaryAssets = (props: UseAncillaryAssetsProps) => {
    const { ancillaryId, ancillary } = useContext(SingleAncillaryContext);

    const { filters } = props;

    const { searchAncillary } = useAssetsApi();

    const [items, setItems] = useState<AssetItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        const request: SearchAncillaryAssetsRequest = {
            ancillaryId: ancillaryId,
            statusIds: filters.statuses,
            page: filters.page,
            pageSize: filters.pageSize,
            sortBy: filters.sortBy,
            sortOrder: filters.sortOrder,
            types: filters.types,
            origins: filters.origins,
            recordTypes: filters.recordTypes,
            createdDateFrom: filters.createdDateFrom?.toISOString(),
            createdDateTo: filters.createdDateTo?.toISOString(),
            updatedDateFrom: filters.updatedDateFrom?.toISOString(),
            updatedDateTo: filters.updatedDateTo?.toISOString()
        };

        searchAncillary(request).then((response: SearchAncillaryAssetsResponse) => {
            const newItems = response.items.map(mapToAssetsListItem);

            setItems(newItems);
            setTotalItems(response.totalCount);

            setIsLoading(false);
        });
    }, [ancillaryId, filters]);

    return {
        items,
        totalItems,
        contentType: ancillary.contentType,
        isLoading
    };
};
